import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';
import { ICON } from 'resources/constants';
import Menu from '../Menu';
import {
  Container,
  BackButton,
  MenuWrapper,
  Header,
  ContentWrapper,
} from './elements';

import { useText, useLink } from 'common/hooks';

type Props = {
  readonly tab: string;
  readonly children: React.ReactNode;
};

const deps = {
  returnUrl: state.account.returnUrl,
};

export function ProfileSettings({
  tab,
  returnUrl,
  children,
}: Props & typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();
  const link = useLink();

  return (
    <Container>
      <BackButton icon={ICON.arrowBack} href={link(returnUrl ? returnUrl : '')}>
        {returnUrl
          ? t('account.settings.back_to_challenge')
          : t('account.settings.back_to_campaigns')}
      </BackButton>
      <MenuWrapper>
        <Header as={'h1'}>{t('account.settings.account')}</Header>
        <ContentWrapper>
          <Menu selectedTab={tab} />
          {children}
        </ContentWrapper>
      </MenuWrapper>
    </Container>
  );
}

export default connect<Props, typeof deps>(deps, ProfileSettings);
